/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { selectUserData } from '../../Redux/UserSlice'
import { useSelector } from 'react-redux';
import axios from 'axios';
import { api_url } from '../../Constants/web_services';
import { Link } from 'react-router-dom';
import moment from 'moment/moment';
const History = () => {
    const userData = useSelector(selectUserData);
    const [historyData, setHistoryData] = useState([]);
    const [data, setData] = useState('')
    const [error, setError] = useState(null);
    const [totalPages, setTotalPages] = useState('');
    const [currentPage, setCurrentPage] = useState('');

    const fetchData = async (page) => {

        try {
            const response = await axios.get(api_url + `/api/order-history/${userData?.id}?page=${page}`);
            setData(response.data.data);
            setHistoryData(response.data?.data?.data);
            setCurrentPage(response.data.data.current_page)
            setTotalPages(response.data?.data?.last_page);
        } catch (err) {
            setError(err);
        }
    };
    useEffect(() => {

        fetchData();
        // eslint-disable-next-line
    }, [userData?.id]);

    const onPageChange = (page) => {
        setCurrentPage(page); // Update current page state
        fetchData(page); // Fetch data for the new page
    };
    const pageNumbers = [...Array(totalPages).keys()].map((num) => num + 1);
    return (
        <div>
            <div id="content">
                <div className="content-admin-main my-5">
                    <div className="admin-top-area border-0 shadow-bx d-flex flex-wrap justify-content-center m-b30 align-items-center">
                        <h2>User History</h2>
                    </div>

                    <div className="aon-admin-heading">
                        {/* <h4 className="s-16 fw-700 text-022279">Edit Profile</h4> */}
                    </div>
                    <div className="card aon-card border-0 shadow">
                        <div className="card-header bg-transparent aon-card-header py-4">
                            <h4 className="s-16 fw-700 text-022279 text-capitalize">
                                <i className="fa fa-history m-2 " />
                                Order History
                            </h4>
                        </div>
                        <div className="card aon-card">
                            <div className="card-body aon-card-body">
                                <div className="sf-bd-data-tb-head">
                                    {/* <button
                                        className="admin-button"
                                        data-toggle="modal"
                                        data-target="#addteammembers"
                                        type="button"
                                    >
                                        <i className="fa fa-plus" />
                                        Add Team Members
                                    </button> */}
                                </div>
                                <div className="sf-bs-data-table">
                                    <div className="table-responsive">
                                        <div
                                            id="DataTables_Table_0_wrapper"
                                            className="dataTables_wrapper dt-bootstrap4 no-footer"
                                        >
                                            <div className="row">
                                                {/* <div className="col-sm-12 col-md-6">
                                                    <div className="dataTables_length" id="DataTables_Table_0_length">
                                                        <label>
                                                            Show{" "}
                                                            <select
                                                                name="DataTables_Table_0_length"
                                                                aria-controls="DataTables_Table_0"
                                                                className="custom-select custom-select-sm form-control form-control-sm"
                                                            >
                                                                <option value={10}>10</option>
                                                                <option value={25}>25</option>
                                                                <option value={50}>50</option>
                                                                <option value={100}>100</option>
                                                            </select>{" "}
                                                            entries
                                                        </label>
                                                    </div>
                                                </div> */}
                                                {/* <div className="col-sm-12 col-md-6">
                                                    <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                                        <label>
                                                            Search:
                                                            <input
                                                                type="search"
                                                                className="form-control form-control-sm"
                                                                placeholder=""
                                                                aria-controls="DataTables_Table_0"
                                                            />
                                                        </label>
                                                    </div>
                                                </div> */}
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <table
                                                        className="table table-sm table-borderless example-dt-table dataTable footer"
                                                        style={{ width: "100%" }}
                                                        id="DataTables_Table_0"
                                                        aria-describedby="DataTables_Table_0_info"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    className=""
                                                                    tabIndex={0}
                                                                    aria-controls="DataTables_Table_0"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Name: activate to sort column ascending"
                                                                // style={{ width: 50 }}
                                                                >
                                                                    Index
                                                                </th>
                                                                <th
                                                                    className=""
                                                                    tabIndex={0}
                                                                    aria-controls="DataTables_Table_0"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Name: activate to sort column ascending"
                                                                // style={{ width: 120 }}
                                                                >
                                                                    Order No #
                                                                </th>
                                                                <th
                                                                    className=""
                                                                    tabIndex={0}
                                                                    aria-controls="DataTables_Table_0"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Phone: activate to sort column ascending"
                                                                // style={{ width: 145 }}
                                                                >
                                                                    Order Status
                                                                </th>
                                                                <th
                                                                    className=""
                                                                    tabIndex={0}
                                                                    aria-controls="DataTables_Table_0"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Email: activate to sort column ascending"
                                                                // style={{ width: 150 }}
                                                                >
                                                                    Payment
                                                                </th>
                                                                <th
                                                                    className=""
                                                                    tabIndex={0}
                                                                    aria-controls="DataTables_Table_0"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Email: activate to sort column ascending"
                                                                // style={{ width: 150 }}
                                                                >
                                                                    Payment date
                                                                </th>
                                                                <th
                                                                    className=""
                                                                    tabIndex={0}
                                                                    aria-controls="DataTables_Table_0"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Email: activate to sort column ascending"
                                                                // style={{ width: 150 }}
                                                                >
                                                                    Payment status
                                                                </th>
                                                                <th
                                                                    className=""
                                                                    tabIndex={0}
                                                                    aria-controls="DataTables_Table_0"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Is Admin?: activate to sort column ascending"
                                                                // style={{ width: 120 }}
                                                                >
                                                                    Company
                                                                </th>
                                                                <th
                                                                    className=""
                                                                    tabIndex={0}
                                                                    aria-controls="DataTables_Table_0"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Is Admin?: activate to sort column ascending"
                                                                // style={{ width: 120 }}
                                                                >
                                                                    Delivered Date
                                                                </th>
                                                                {/* <th
                                                                    className=""
                                                                    tabIndex={0}
                                                                    aria-controls="DataTables_Table_0"
                                                                    rowSpan={1}
                                                                    colSpan={1}
                                                                    aria-label="Action: activate to sort column ascending"
                                                                    style={{ width: 77 }}
                                                                >
                                                                    Action
                                                                </th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {historyData.length > 0 ? (
                                                                historyData.map((history, index) => (
                                                                    <tr key={index} className="shadow-lg">
                                                                        <td className='fw-700'>{index + 1}</td>

                                                                        <td className=' fw-700'>{history?.order_no}</td>
                                                                        <td className={history?.order_status === 'Order Cancel' ? 'text-danger fw-600' : 'fw-600 text-success'}>
                                                                            {history?.order_status}
                                                                        </td>
                                                                        <td className={history?.order_status === 'Order Cancel' ? 'text-danger fw-600' : 'fw-600 text-022279'}>{history.payment ? (history.payment * 0.8).toFixed('') : '-'}</td>
                                                                        <td className={`${(history?.order_payment?.refund_date) ? "" : "fw-700"} `}>{(history?.order_payment?.refund_date) ? moment(history?.order_payment?.refund_date)?.format('DD-MM-YYYY') : '- -'}</td>

                                                                        <td>
                                                                            <span className={`btn btn-sm fw-600 text-uppercase ${history?.order_payment?.refund_date ? 'btn-danger' : 'btn-success'}`}>
                                                                                {history?.order_payment?.refund_date ? 'Refund' : 'Paid'}
                                                                            </span>
                                                                        </td>


                                                                        <td> <span className='btn btn-sm btn-primary fw-600 text-uppercase'>
                                                                            {history?.company?.name}</span></td>

                                                                        <td className='fw-700'>{moment(history?.updated_at).format('DD-MM-YYYY')}</td>

                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <><h3 className="text-center text-capitalize">no orders yet</h3></>
                                                            )}


                                                            {/* // <tr className="odd">

                                                            //     <td>James Miller</td>
                                                            //     <td>+01 234 567 89</td>
                                                            //     <td>xyz78576@gmail.com</td>
                                                            //     <td>Yes</td>
                                                            //     <td />
                                                            // </tr>
                                                            // <tr className="even">

                                                            //     <td>Devid</td>
                                                            //     <td>+01 234 567 67</td>
                                                            //     <td>demo123@gmail.com</td>
                                                            //     <td>No</td>
                                                            //     <td />
                                                            // </tr> */}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {currentPage >= 2 ? <>
                                                <div className="row">
                                                    <div className="col-sm-12 col-md-5">
                                                        <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">
                                                            Showing {data?.from} to {data?.to} of {data?.total} entries
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-12 col-md-7">
                                                        <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate">
                                                            <ul className="pagination">
                                                                <li className={`paginate_button page-item previous ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                    <Link
                                                                        to={`/${currentPage - 1}`} // Link to the previous page
                                                                        className="page-link"
                                                                        onClick={() => onPageChange(currentPage - 1)}
                                                                    >
                                                                        Previous
                                                                    </Link>
                                                                </li>
                                                                {pageNumbers.map((page) => (
                                                                    <li key={page} className={`paginate_button page-item ${currentPage === page ? 'active' : ''}`}>
                                                                        <Link
                                                                            to={`/${page}`} // Link to each page
                                                                            className="page-link"
                                                                            onClick={() => onPageChange(page)}
                                                                        >
                                                                            {page}
                                                                        </Link>
                                                                    </li>
                                                                ))}
                                                                <li className={`paginate_button page-item next ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                    <Link
                                                                        to={`/${currentPage + 1}`} // Link to the next page
                                                                        className="page-link"
                                                                        onClick={() => onPageChange(currentPage + 1)}
                                                                    >
                                                                        Next
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </> : <></>}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div >
    )
}

export default History
